export const HasSamePolyline = (currentStop, newStop) => {
  return (
    currentStop?.fromLat === newStop?.fromLat &&
    currentStop?.fromLng === newStop?.fromLng
  );
};
